// extracted by mini-css-extract-plugin
export default {"main":"OpponentHandCards_main__wlQNy","cardContainer":"OpponentHandCards_cardContainer__A4Rn+","card":"OpponentHandCards_card__jJ7Wu"};